import { createSelector } from 'reselect';

const selector = (state) => state.toJS().userReducer;

/**
 * Retrieves user state from user reducer
 */
export const userSelector = createSelector(selector, (users) => users.user);

export default userSelector;
